import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

export function Markdown({ children, className = "" }: Props) {
  return (
    <ReactMarkdown remarkPlugins={[remarkGfm]} className={`prose prose-sm ${className}`}>
      {children}
    </ReactMarkdown>
  );
}

interface Props {
  children: any;
  className?: string;
}
